###
 * Make a container closable
 * @package Syltaen
 * @author Stanley Lambot
 * @requires jQuery
###

import $ from "jquery";


# ==================================================
# > CLASS
# ==================================================
class Collapsable

    constructor: (@$el, @trigger, @body, @all) ->
        @$trigger = @$el.find(@trigger)
        @$body    = @$el.find(@body)
        @opened   = true

        @close 0
        @bindClick()

    close: (speed = 300) ->
        @$body.stop().slideUp speed
        @$el.removeClass "is-open"
        @opened = false

    open: (speed = 300) ->
        @all.closeAll()
        @$body.stop().slideDown speed, -> $(window).resize()
        @$el.addClass "is-open"
        @opened = true

    toggle: ->
        if @opened then @close() else @open()

    bindClick: ->
        @$trigger.click => @toggle()


class Collapsables
    constructor: ->
        @list = []

    add: ($el, trigger, body) ->
        @list.push new Collapsable $el, trigger, body, @

    closeAll: ->
        $.each @list, (i, el) -> if el.opened then el.close()

# ==================================================
# > OBJECTS
# ==================================================
collection = new Collapsables()

# ==================================================
# > JQUERY METHOD
# ==================================================
$.fn.collapsable = (trigger = ".collapsable__header", body = ".collapsable__content") ->
    $(this).each -> collection.add $(this), trigger, body
    return $(this)



// WEBPACK FOOTER //
// ./scripts/tools/collapsable.coffee